import { updatePrivacySettingsLocally } from '../updatePrivacySettingsLocally/updatePrivacySettingsLocally';

export async function getPrivacySettings() {
  try {
    // Needs Bff implementation
    const settings = {
      addToGroup: 'ANYONE',
      addToPublic: 'ANYONE',
      callMe: 'ANYONE',
      searchMe: 'ANYONE',
      sendVoiceMessage: 'ANYONE',
      showAvatar: 'ANYONE',
      showLastSeen: 'ANYONE',
      showPhoneNumber: 'CONTACTS',
      updateTs: '1705592927947',
    };

    updatePrivacySettingsLocally(settings);
  } catch (error) {
    console.error('Task: Privacy Settings error', error);
  }
}
